// import { I18n } from '@ies/starling_intl';
export const getFullUrl = (num: number) => {
  return window.$isOversea
    ? `https://lf16-oversea.goofy-cdn.com/obj/goofy-sg/cg/ngcc/linkchat_static/emoji/im_mobile_emoji_icon_${num}.png`
    : `https://lf3-cdn-tos.bytegoofy.com/obj/goofy/cg/ngcc/linkchat_static/emoji/im_mobile_emoji_icon_${num}.png`;
  // return window.$isOversea
  //   ? `https://sf16-sg.tiktokcdn.com/obj/eden-sg/bzbzhsweh7upivhog/emoji/im_mobile_emoji_icon_${num}.png`
  //   : `https://sf3-ttcdn-tos.yangyi08.com/obj/eden-cn/nulojubqbk/cg-fe-djc/im_mobile_emoji_icon_${num}.png`;
};

const map = {
  微笑: 1,
  爱慕: 2,
  惊呆: 3,
  酷拽: 4,
  抠鼻: 5,
  流泪: 6,
  发怒: 7,
  呲牙: 8,
  鼾睡: 9,
  害羞: 10,
  可爱: 11,
  晕: 12,
  衰: 13,
  闭嘴: 14,
  机智: 15,
  来看我: 16,
  灵光一闪: 17,
  耶: 18,
  捂脸: 19,
  打脸: 20,
  大笑: 21,
  哈欠: 22,
  震惊: 23,
  送心: 24,
  困: 25,
  what: 26,
  泣不成声: 27,
  小鼓掌: 28,
  大金牙: 29,
  偷笑: 30,
  石化: 31,
  思考: 32,
  吐血: 33,
  可怜: 34,
  嘘: 35,
  撇嘴: 36,
  黑线: 37,
  笑哭: 38,
  雾霾: 39,
  奸笑: 40,
  得意: 41,
  憨笑: 42,
  抓狂: 43,
  泪奔: 44,
  钱: 45,
  吻: 46,
  恐惧: 47,
  笑: 48,
  快哭了: 49,
  翻白眼: 50,
  互粉: 51,
  赞: 52,
  鼓掌: 53,
  祈祷: 54,
  kiss: 55,
  去污粉: 56,
  666: 57,
  玫瑰: 58,
  胡瓜: 59,
  啤酒: 60,
  我想静静: 61,
  委屈: 62,
  舔屏: 63,
  鄙视: 64,
  飞吻: 65,
  再见: 66,
  紫薇别走: 67,
  听歌: 68,
  求抱抱: 69,
  周冬雨的凝视: 70,
  马思纯的微笑: 71,
  吐舌: 72,
  呆无辜: 73,
  看: 74,
  白眼: 75,
  熊吉: 76,
  骷髅: 77,
  黑脸: 78,
  吃瓜群众: 79,
  绿帽子: 80,
  汗: 81,
  摸头: 82,
  皱眉: 83,
  擦汗: 84,
  红脸: 85,
  尬笑: 86,
  做鬼脸: 87,
  强: 88,
  如花: 89,
  吐: 90,
  惊喜: 91,
  敲打: 92,
  奋斗: 93,
  吐彩虹: 94,
  大哭: 95,
  比心: 96,
  加油: 97,
  碰拳: 98,
  ok: 99,
  击掌: 100,
  左上: 101,
  握手: 102,
  '18禁': 103,
  刀: 104,
  V5: 105,
  给力: 106,
  心: 107,
  伤心: 108,
  屎: 109,
  礼物: 110,
  蛋糕: 111,
  撒花: 112,
  不看: 113,
  炸弹: 114,
};

// According to the name, find the corresponding number key.
export const nameToiconMap = Object.keys(map).reduce(
  (acc: Record<string, number>, key) => {
    acc[`[${key}]`] = map[key];
    return acc;
  },
  {},
);

// Find the name by the key
export const iconTonameMap = Object.keys(map).reduce(
  (acc: Record<number, string>, key) => {
    acc[map[key]] = `[${key}]`;
    return acc;
  },
  {},
);

const split = (content: string, world: string) => {
  const index = content.indexOf(world);
  return {
    firstWord: content.substring(0, index),
    lastWord: content.substring(index + world.length, content.length),
  };
};

const renderEmojiDom = (size: number, url: string) => {
  return `<img src="${url}" style="height: ${size}px; width: ${size}px; margin: 0 2px; vertical-align: text-top;"/>`;
};

// Determine if there is an emoji in the string
export const parseEmoji = (content: string, size: number = 28) => {
  if (!content) return '';
  // Non-greedy mode
  const pattern = /\[\S+?\]/g;
  const emojiStrs = content.match(pattern);
  if (!emojiStrs) return content;
  const contentDoms = [];
  for (let i = 0; i < emojiStrs.length; i++) {
    let word = emojiStrs[i];
    if (!nameToiconMap[word]) {
      continue;
    }
    const splitResult = split(content, word);
    if (splitResult.firstWord) {
      contentDoms.push(splitResult.firstWord);
    }
    let url = getFullUrl(nameToiconMap[word]);
    contentDoms.push(renderEmojiDom(size, url));
    content = splitResult.lastWord;
  }
  if (content) contentDoms.push(content); // The last split text also needs to be rendered
  return contentDoms.join('');
};
